import { render } from "./z-deadline.vue?vue&type=template&id=13a73f8f"
import script from "./z-deadline.vue?vue&type=script&lang=js"
export * from "./z-deadline.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__